"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinsGridView = SpinsGridView;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _uxUtils = require("@site/ux-utils");
var _utils = require("./utils");
var _SpinsHeader = require("./SpinsHeader");
var _DomainEntries = _interopRequireDefault(require("./SpinResults/DomainEntries"));
var _gridStyling = require("./styles/gridStyling");
var _useApiData = require("./hooks/useApiData");
var _RequestApiType = _interopRequireDefault(require("./constants/RequestApiType"));
var _SpinAddToCartButton = _interopRequireDefault(require("./SpinResults/SpinAddToCartButton"));
var _sharedComponents = require("@site/shared-components");
var _LoadingEmptyStateContent = _interopRequireDefault(require("./components/LoadingEmptyStateContent"));
var _SpinsComponentLoader = require("./SpinsComponentLoader");
// eslint-disable-next-line complexity
function SpinsGridView(props) {
  const {
    language = {}
  } = {
    ...props
  };
  const {
    overrideProps,
    languageStrings
  } = (0, _sharedComponents.useComponentDataProvider)(language);
  const {
    spinsResponse = {},
    options = {},
    AddToCartButton,
    PriceBlock,
    CustomCartStateBadge,
    CelebrateDetailView = () => /*#__PURE__*/_react.default.createElement("div", null),
    SpinInCartExpandedComponent = () => /*#__PURE__*/_react.default.createElement("div", null),
    PremiumDetailView = () => /*#__PURE__*/_react.default.createElement("div", null),
    SpinsSolutionSets = () => /*#__PURE__*/_react.default.createElement("div", null),
    enableDynamicFontScaling = false,
    cartContents,
    requestApiType,
    apm,
    customLoadingSpinner,
    ctaProps = {},
    emptyStateComponent,
    onSuccessApiData,
    spinsHeaderComponent,
    columns = 3
  } = {
    ...props,
    ...overrideProps
  };
  const {
    spinsData,
    requestStatus
  } = (0, _useApiData.useApiData)(requestApiType, {
    ...options,
    ...options.extraApiParam
  }, apm, onSuccessApiData);
  const spinsResponseData = requestApiType ? spinsData : spinsResponse;
  const {
    market = 'en-US',
    showFreeIndicator,
    removeTopBorder,
    spinsHeader: {
      showSpinsHeader
    } = {},
    maxSpins = 40,
    isSpinExpandable,
    isClickable = true
  } = options;
  const {
    isMobile
  } = (0, _uxUtils.useDeviceType)();
  const showLoadMoreButton = false;
  const recommendedDomains = (0, _utils.transformSpinData)({
    findResponse: spinsResponseData,
    showFreeIndicator,
    maxSpins
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "styled-spins-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
    locale: market,
    key: market,
    messages: languageStrings
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "spins-grid-layout-view",
    className: (0, _classnames.default)('spin-and-filter-wrap', 'bg-white', {
      'card-view': isMobile,
      'pb-4': !isMobile && !showLoadMoreButton
    })
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('d-flex align-items-end', {
      'justify-content-between': showSpinsHeader,
      'justify-content-end': !showSpinsHeader
    })
  }, showSpinsHeader && /*#__PURE__*/_react.default.createElement(_SpinsHeader.SpinsHeader, {
    options: options
  }), spinsHeaderComponent), /*#__PURE__*/_react.default.createElement(_LoadingEmptyStateContent.default, {
    requestApiType,
    requestStatus,
    emptyStateComponent,
    customLoadingSpinner,
    recommendedDomains
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('detailed-v-panel panel panel-default', {
      'remove-top-border': removeTopBorder && !isSpinExpandable
    })
  }, recommendedDomains.length > 0 && /*#__PURE__*/_react.default.createElement(_gridStyling.SpinsGrid, {
    columns: columns,
    "data-cy": "spin-grid-container",
    isClickable: isClickable
  }, /*#__PURE__*/_react.default.createElement(_DomainEntries.default, {
    language: languageStrings,
    recommendedDomains: recommendedDomains,
    dataCy: "card-layout-spin",
    options: {
      ...options,
      isClickable
    },
    PriceBlock: PriceBlock,
    ctaProps: {
      apiKey: options?.apiKey,
      env: options?.env,
      ...ctaProps
    },
    CustomCartStateBadge: CustomCartStateBadge,
    AddToCartButton: AddToCartButton,
    CelebrateDetailView: CelebrateDetailView,
    SpinInCartExpandedComponent: SpinInCartExpandedComponent,
    PremiumDetailView: PremiumDetailView,
    SpinsSolutionSets: SpinsSolutionSets,
    showDetailView: true,
    enableDynamicFontScaling: enableDynamicFontScaling,
    cartContents: cartContents,
    gridNumOfColumns: columns
  })))))));
}
const ctaPropsPropTypes = {
  ..._SpinAddToCartButton.default.propTypes
};
delete ctaPropsPropTypes.product;
SpinsGridView.propTypes = {
  language: _propTypes.default.object,
  spinsResponse: _propTypes.default.object,
  options: _propTypes.default.object,
  AddToCartButton: _propTypes.default.func,
  PriceBlock: _propTypes.default.func,
  CelebrateDetailView: _propTypes.default.func,
  PremiumDetailView: _propTypes.default.func,
  SpinsSolutionSets: _propTypes.default.func,
  enableDynamicFontScaling: _propTypes.default.object,
  cartContents: _propTypes.default.shape({
    has: _propTypes.default.func
  }),
  SpinInCartExpandedComponent: _propTypes.default.element,
  CustomCartStateBadge: _propTypes.default.element,
  requestApiType: _propTypes.default.oneOf(_RequestApiType.default),
  apm: _propTypes.default.object,
  customLoadingSpinner: _propTypes.default.element,
  ctaProps: _propTypes.default.shape(ctaPropsPropTypes),
  emptyStateComponent: _propTypes.default.element,
  onSuccessApiData: _propTypes.default.func,
  spinsHeaderComponent: _propTypes.default.element,
  columns: _propTypes.default.number
};
const SpinsGridViewWithComponentDataProvider = props => {
  const {
    appName,
    apiKey,
    plid,
    urlOverride,
    options: {
      enableFavorites
    } = {},
    uipProps,
    forceEnableBFF
  } = props;
  return /*#__PURE__*/_react.default.createElement(_sharedComponents.ComponentDataProvider, (0, _extends2.default)({
    appName: appName,
    componentName: "spins",
    apiKey: apiKey,
    loader: /*#__PURE__*/_react.default.createElement(_SpinsComponentLoader.SpinsComponentLoader, null),
    forceEnableBFF: forceEnableBFF
  }, enableFavorites && {
    uipProps: {
      plid,
      urlOverride,
      ...uipProps
    }
  }), /*#__PURE__*/_react.default.createElement(SpinsGridView, props));
};
SpinsGridViewWithComponentDataProvider.propTypes = {
  ...SpinsGridView.propTypes,
  uipProps: _propTypes.default.object,
  forceEnableBFF: _propTypes.default.bool
};
var _default = exports.default = SpinsGridViewWithComponentDataProvider;